import { FormEvent, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { ApiError } from "../api";
import { useAuth } from "../auth";

export function LoginPage() {
  const { token, login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (token) return <Navigate to="/" replace />;

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(username, password);
      navigate("/", { replace: true });
    } catch (err) {
      const e = err as ApiError;
      setError(e.status === 401 ? "Bad credentials" : e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="card p-8 w-full max-w-sm">
        <h1 className="text-xl font-semibold mb-1">Kepler MCP Portal</h1>
        <p className="text-sm text-slate-500 mb-6">Sign in with your MCP account.</p>
        <form onSubmit={onSubmit} className="space-y-4">
          <label className="block">
            <span className="text-xs text-slate-600 uppercase tracking-wide">Username</span>
            <input
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="input mt-1"
              autoComplete="username"
              required
            />
          </label>
          <label className="block">
            <span className="text-xs text-slate-600 uppercase tracking-wide">Password</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input mt-1"
              autoComplete="current-password"
              required
            />
          </label>
          {error && (
            <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded px-3 py-2">
              {error}
            </div>
          )}
          <button type="submit" disabled={busy} className="btn-primary w-full justify-center">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <p className="text-xs text-slate-500 mt-6">
          Forgot your password? Ask an admin to reset it via{" "}
          <code>POST /api/admin/users/:id/password</code>.
        </p>
      </div>
    </div>
  );
}
